import React from 'react';

function CandleDetails({ label, time, candle }) {
  if (!time) return null;
  return <details className="text-xs text-gray-600">
    <summary className="cursor-pointer">{label}: {time} (NY)</summary>
    {candle && <p>Open {candle.open} · High {candle.high} · Low {candle.low} · Close {candle.close}</p>}
  </details>;
}

export default function ConfirmationCandle({ prediction }) {
  return <>
    <CandleDetails label="Breakout confirmation" time={prediction.breakout_confirmation_time} candle={prediction.breakout_confirmation_candle} />
    <CandleDetails label="Retest" time={prediction.retest_time} candle={prediction.retest_candle} />
    <CandleDetails label="Entry confirmation" time={prediction.confirmation_time} candle={prediction.confirmation_candle} />
  </>;
}
